import {
  Directive, Input, TemplateRef, ViewContainerRef, OnDestroy, ChangeDetectorRef
} from '@angular/core';
import { BreakPointRegistry } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import { startWith, switchMap, map } from 'rxjs/operators';
import { BreakpointObserver } from '@angular/cdk/layout';

@Directive({
  selector: '[sonderMediaqueryIf]',
})
export class MediaqueryIfDirective implements OnDestroy {
  private hasView = false;
  private matcher = new Subject<string>();
  private subscription = this.matcher
    .pipe(
      map((alias) => this.breakpoints.findByAlias(alias)),
      switchMap((bp) => {
        const mq = bp.mediaQuery;
        return this.breakpointObs.observe(mq).pipe(
          map((bt) => bt.matches),
          startWith(this.breakpointObs.isMatched(mq))
        );
      }),
    )
    .subscribe((matches) => (matches ? this.createView() : this.destroyView()));

  @Input()
  set sonderMediaqueryIf(value: string) {
    this.matcher.next(value);
  }

  constructor(
    private template: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private breakpoints: BreakPointRegistry,
    private breakpointObs: BreakpointObserver,
    private changeRef: ChangeDetectorRef,
  ) {}

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private createView() {
    if (!this.hasView) {
      this.viewContainer.createEmbeddedView(this.template);
      this.changeRef.markForCheck();
      this.hasView = true;
    }
  }

  private destroyView() {
    if (this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
